import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  reviewCart(e) {
    e.preventDefault();

    const form = e.target.form;

    if (!form.reportValidity()) {
      e.stopImmediatePropagation();
      return;
    }

    const accessCode = form.children.EWAY_ACCESSCODE.value;

    fetch(`/cart/review?AccessCode=${accessCode}`)
      .then((response) => {
        if (!response.ok) {
          window.location.replace('/cart');
          return null;
        }

        return response.json();
      })
      .then((data) => {
        if (!data) return;

        const cart_price = parseFloat(
          data['cart']['total_with_shipping'],
        ).toFixed(2);
        const form_price = (data['eway']['total_amount'] / 100).toFixed(2);

        if (cart_price === form_price) {
          form.requestSubmit();
        } else {
          window.location.replace('/cart/review?cart_updated=true');
        }
      });
  }
}
